import React, { useEffect, useState, useCallback, useRef } from "react";
import { CustomDatePicker } from "./CustomDatePicker";
import { format } from 'date-fns';
import noimage from '../../assets/images/Desktop placeholder.svg'
import config from "../../config";
import tentStyles from "./TentHouseService.module.css";
import styles from "./PriestManagerService.module.css";
import PriestPackageComponent from "./PriestPackageComponent";
import { CategoryFallbackIcon } from "./PriestCategoryIcons";
import {
  getPriestEvents,
  getPriestProviderEvents,
  savePriestEvents,
} from "../../Apiservices/Auth/servers/fetchProviderData";

function PriestManageServices(props) {
  const [loading, setLoading] = useState(true);
  const [priestEventMaster, setPriestEventMaster] = useState([]);
  const [priestEventMasterFiltered, setPriestEventMasterFiltered] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [hasErrors, setHasErrors] = useState(false);
  const [saving, setSaving] = useState(false);
  const [savingEventId, setSavingEventId] = useState(null); // Track which event is being saved
  const [showPackageModal, setShowPackageModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const INDICATOR_CONFIG = {
    highlightRow: true,
    highlightCell: false,
    showRedDot: false,
    showUnsavedLabel: true,
  };

  // Auto-save timeout reference
  const saveTimeoutRef = React.useRef(null);

  // Fetch services data
  const resultedServicesFunc = useCallback(async () => {
    setLoading(true);
    try {
      const priestEventMaster = await getPriestEvents();
      const priesAddedServices = await getPriestProviderEvents();
      let transformedData = [];
      console.log("priestEventMaster", priestEventMaster)
      priestEventMaster.sort((a, b) => a.name.localeCompare(b.name));

      priestEventMaster.forEach((category) => {
        const newCategory = {
          id: category.id,
          categoryName: category.name,
          categoryDescription: category.longDescription,
          events: [],
          isOpen: false,
          imageid: category.image_id || null,
        };

        let mappedEvents = [];
        let unmappedEvents = [];

        category.events.forEach((event) => {
          const existingEvent = priesAddedServices.find(
            (mapped) =>
              mapped.categoryId === category.id &&
              mapped.events.some(
                (mappedEvent) => mappedEvent.eventId === event.id
              )
          );

          const newEvent = {
            id: event.id,
            name: event.name,
            categoryId: category.id,
            description: event.description,
            imageid: event.image_id,
            eventMappingId: existingEvent
              ? existingEvent.events.find((e) => e.eventId === event.id)
                ?.eventMappingId
              : "",
            price: existingEvent
              ? existingEvent.events.find((e) => e.eventId === event.id)?.price
              : "",
            discountPrice: existingEvent
              ? existingEvent.events.find((e) => e.eventId === event.id)
                ?.discountPrice
              : "",
            discountValidUpto: existingEvent
              ? existingEvent.events.find((e) => e.eventId === event.id)
                ?.discountValidUpto
              : "",
            toSave: false,
            errorMessage: "",
            alreadyMapped: !!existingEvent,
          };

          if (newEvent.alreadyMapped) {
            mappedEvents.push(newEvent);
          } else {
            unmappedEvents.push(newEvent);
          }
        });

        mappedEvents.sort((a, b) => a.name - b.name);
        unmappedEvents.sort((a, b) => a.name - b.name);
        newCategory.events = [...mappedEvents, ...unmappedEvents];
        transformedData.push(newCategory);
      });
      const newCategoryOption = {
        id: 'package', // Special ID for new category
        categoryName: 'Package',
        categoryDescription: 'Click to create a new category',
        events: [],
        isOpen: false,
        imageid: null,
        isNewCategory: true, // Flag to identify this is the "add new" option
      };
      transformedData.push(newCategoryOption)
      console.log("priestEventMaster q", transformedData)
      setPriestEventMaster(transformedData);
      setPriestEventMasterFiltered(transformedData);
    } catch (error) {
      console.error("Failed to fetch services:", error);
    } finally {
      setLoading(false);
      setHasErrors(false);
    }
  }, []);

  useEffect(() => {
    resultedServicesFunc();
  }, []);

  useEffect(() => {
    if (props.initialCategoryId) {
      setSelectedCategoryId(props.initialCategoryId);
      props.onClearInitialCategory?.();
    }
  }, [props.initialCategoryId, props.onClearInitialCategory]);

  const autoSaveChanges = async (categoryId, eventId) => {
    console.log(`Starting auto-save for event ${eventId}`); // Debug log

    // Get the current state directly from setState callback
    setPriestEventMaster(prevState => {
      const eventsToSave = prevState.flatMap((category) =>
        category.events.filter((event) => event.toSave)
      );

      console.log('Auto-saving events:', eventsToSave.map(e => ({
        id: e.id,
        toSave: e.toSave,
        price: e.price,
        discountPrice: e.discountPrice,
        discountValidUpto: e.discountValidUpto
      }))); // Debug log

      if (eventsToSave.length === 0) {
        console.log('No events to save'); // Debug log
        return prevState;
      }

      const updatedData = eventsToSave.map((event) => ({
        eventMappingId: event.eventMappingId,
        eventId: event.id,
        price: event.price || null, // Convert empty string to null for backend
        discountPrice: event.discountPrice || null, // Convert empty string to null for backend
        discountValidUpto: event.discountValidUpto || null, // Convert empty string to null for backend
      }));

      console.log('Sending data to API:', updatedData); // Debug log

      // Call the API and handle the save
      (async () => {
        try {
          setSaving(true);
          setSavingEventId(eventId);
          console.log(`Calling savePriestEvents API for event ${eventId}`); // Debug log
          await savePriestEvents(updatedData);

          console.log(`Successfully saved event ${eventId}`); // Debug log

          // Reset toSave flags after successful save
          setPriestEventMaster(prev => prev.map(category => ({
            ...category,
            events: category.events.map(event => ({
              ...event,
              toSave: false
            }))
          })));

          setPriestEventMasterFiltered(prev => prev.map(category => ({
            ...category,
            events: category.events.map(event => ({
              ...event,
              toSave: false
            }))
          })));

        } catch (error) {
          console.error("Auto-save failed:", error);
        } finally {
          setSaving(false);
          setSavingEventId(null);
        }
      })();

      return prevState;
    });
  };

  // Manually trigger a save for a single event (used by the per-event Save button).
  // Clears any pending debounce timeout so we don't double-save, then saves immediately.
  const handleManualSave = (categoryId, eventId) => {
    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current);
      saveTimeoutRef.current = null;
    }
    autoSaveChanges(categoryId, eventId);
  };

  // Validate fields function
  const validateFields = (event) => {
    let errors = [];

    if (event.discountPrice && Number(event.discountPrice) > Number(event.price)) {
      errors.push("Offer price must be less than or equal to price.");
    }

    if (event.discountValidUpto && new Date(event.discountValidUpto) < new Date()) {
      errors.push("Discount valid date cannot be in the past.");
    }

    // Check if offer price is entered but offer end date is missing
    if (event.discountPrice && event.discountPrice !== '' && !event.discountValidUpto) {
      errors.push("Offer end date is required when offer price is provided.");
    }

    if ((event.discountPrice || event.discountValidUpto) && (!event.price || Number(event.price) <= 0)) {
      errors.push("Price is required when offer price or discount valid date is provided.");
    }

    return errors.length > 0 ? errors.join(" ") : "";
  };

  const handleInputChange = (categoryId, eventId, field, value) => {
    // Clear previous timeout
    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current);
    }

    const updateStates = (prevState) =>
      prevState.map((category) => {
        if (category.id === categoryId) {
          return {
            ...category,
            events: category.events.map((event) => {
              if (event.id === eventId) {
                let updatedEvent = { ...event, [field]: value };

                // If price is cleared, also clear discount price and discount valid until
                if (field === 'price' && (value === '' || value === null)) {
                  updatedEvent = {
                    ...updatedEvent,
                    discountPrice: "",
                    discountValidUpto: ""
                  };
                }

                // If discount price is cleared, also clear discount valid until
                if (field === 'discountPrice' && (value === '' || value === null)) {
                  updatedEvent = {
                    ...updatedEvent,
                    discountValidUpto: ""
                  };
                }

                const errorMessage = validateFields(updatedEvent);

                console.log(`Setting event ${eventId} toSave: true for field: ${field}, value: ${value}`); // Debug log

                return {
                  ...updatedEvent,
                  toSave: true, // Always mark for save (both clearing and entering)
                  errorMessage: errorMessage,
                };
              }
              return event;
            }),
          };
        }
        return category;
      });

    setPriestEventMaster(prev => {
      const newState = updateStates(prev);
      // Debug: Check the updated state immediately
      const updatedEvent = newState.find(c => c.id === categoryId)?.events.find(e => e.id === eventId);
      console.log(`Event ${eventId} toSave after update:`, updatedEvent?.toSave, 'Field:', field, 'Value:', value);
      return newState;
    });

    setPriestEventMasterFiltered(updateStates);

    // Saving now happens ONLY when the person explicitly presses the Save
    // button on the event card (see handleManualSave). We just mark the
    // field as changed (toSave: true) above so the Save button lights up.
  };

  // Clear specific field function with auto-save
  // Clear specific field function with auto-save
  const handleClearField = (categoryId, eventId, field) => {
    console.log(`Clearing field ${field} for event ${eventId} via clear button`); // Debug log

    const updateStates = (prevState) =>
      prevState.map((category) => {
        if (category.id === categoryId) {
          return {
            ...category,
            events: category.events.map((event) => {
              if (event.id === eventId) {
                let updatedEvent = { ...event, [field]: "" };

                // If clearing price, also clear discount fields
                if (field === 'price') {
                  updatedEvent = {
                    ...updatedEvent,
                    discountPrice: "",
                    discountValidUpto: ""
                  };
                }
                // If clearing discount price, also clear discount valid until
                else if (field === 'discountPrice') {
                  updatedEvent = {
                    ...updatedEvent,
                    discountValidUpto: ""
                  };
                }

                const errorMessage = validateFields(updatedEvent);

                console.log(`Setting event ${eventId} toSave: true after clearing ${field}`, {
                  price: updatedEvent.price,
                  discountPrice: updatedEvent.discountPrice,
                  discountValidUpto: updatedEvent.discountValidUpto,
                  toSave: true
                }); // Debug log

                return {
                  ...updatedEvent,
                  toSave: true, // Always mark for save when clearing
                  errorMessage: errorMessage,
                };
              }
              return event;
            }),
          };
        }
        return category;
      });

    setPriestEventMaster(prev => {
      const newState = updateStates(prev);
      const updatedEvent = newState.find(c => c.id === categoryId)?.events.find(e => e.id === eventId);
      console.log(`Event ${eventId} state after clear:`, updatedEvent); // Debug log

      // Also update the filtered state
      setPriestEventMasterFiltered(updateStates(prev));

      return newState;
    });

    // Saving now happens ONLY when the person explicitly presses the Save
    // button on the event card, same as any other field change above.
  };






  const handleSearchChange = (value) => {
    setSearchTerm(value);
    if (!value.trim()) {
      setPriestEventMasterFiltered(priestEventMaster);
      return;
    }
    const filtered = priestEventMaster.filter(
      (category) =>
        category.id === "package" ||
        category.categoryName.toLowerCase().includes(value.toLowerCase())
    );
    setPriestEventMasterFiltered(filtered);
  };

  const handleCategorySelect = (categoryId) => {
    if (categoryId === 'package') {
      setSelectedCategoryId('package');
    } else {
      setSelectedCategoryId(categoryId);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });

  };

  // Note: previously this auto-selected the first category as soon as data
  // loaded, which caused the events panel (e.g. "Anniversary Events") to pop
  // open immediately on page load. Now nothing is selected until the user
  // actually taps a category card.

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
        <h3 style={{ textAlign: "center" }}>
          <i
            className="pi pi-spin pi-spinner-dotted"
            style={{ fontSize: "2rem", color: "#0cc0df" }}
          ></i>
        </h3>
      </div>
    );
  }

  return (
    <main>
      <div className={tentStyles.buttonFrameRow}>
        <div className={tentStyles.errorNotice}>
          {hasErrors ? "Please resolve all errors" : ""}
          {saving && (
            <span className={styles.savingIndicator}>
              <i className="pi pi-spin pi-spinner" style={{ marginRight: '8px' }}></i>
              Auto-saving...
            </span>
          )}
        </div>
      </div>

      <div className={styles.categoriesContainer}>
        {!selectedCategoryId ? (
          /* Category selection screen - matches the app's "Priest Services" screen exactly */
          <div className={styles.categoriesPanel}>
            <h2 className={styles.panelTitle}>Priest Services</h2>

            <div className={styles.searchBox}>
              <i className="pi pi-search" style={{ color: "#9e9e9e", fontSize: "16px" }}></i>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => handleSearchChange(e.target.value)}
                placeholder="Search category"
                className={styles.searchInput}
              />
            </div>

            <div className={styles.categoryGrid}>
              {priestEventMasterFiltered
                .filter((category) => category.id !== "package")
                .map((category) => (
                  <div
                    key={category.id}
                    className={styles.categoryCard}
                    onClick={() => handleCategorySelect(category.id)}
                  >
                    {category?.imageid ? (
                      <img
                        alt={category.categoryName}
                        src={`${config.API_BASE_URL}/gallery/download/${category.imageid}`}
                        className={styles.categoryIcon}
                        onError={(e) => {
                          e.target.style.display = "none";
                          e.target.nextSibling.style.display = "flex";
                        }}
                      />
                    ) : null}
                    <div
                      className={styles.categoryIcon}
                      style={{
                        display: category?.imageid ? "none" : "flex",
                        overflow: "hidden",
                        borderRadius: "8px",
                      }}
                    >
                      <CategoryFallbackIcon categoryName={category.categoryName} />
                    </div>
                    <span className={styles.categoryLabel}>
                      {category.categoryName}
                    </span>
                  </div>
                ))}
            </div>

            <div className={styles.orDivider}>
              <span className={styles.orLine}></span>
              <span className={styles.orText}>OR</span>
              <span className={styles.orLine}></span>
            </div>

            <button
              type="button"
              className={styles.customPackageBtn}
              onClick={() => handleCategorySelect("package")}
            >
              Create Custom Package
            </button>
          </div>
        ) : (
          /* Detail screen - "redirected" view for the tapped category / package */
          <div className={styles.detailPanel}>
            <button
              type="button"
              className={`${styles.backButton} ${styles.backButtonBlue}`}
              onClick={() => setSelectedCategoryId(null)}
            >
              <i className="pi pi-arrow-left"></i> Back to Priest Services
            </button>

            {selectedCategoryId === "package" ? (
              <PriestPackageComponent
                onClose={() => setSelectedCategoryId(null)}
                onSave={(newPackage) => {
                  console.log("New package created:", newPackage);
                }}
              />
            ) : (
              priestEventMasterFiltered
                .filter((category) => category.id === selectedCategoryId)
                .map((category) => (
                  <div key={category.id}>
                    <div className={styles.categoryHeader}>
                      <h2 className={styles.categoryTitle}>{category.categoryName} Events</h2>
                      <span className={styles.titleundertext}>Please enter price, offer price, and offer ends</span>
                    </div>
                    <div className={styles.eventsGrid}>
                      {category.events.map((event) => (
                        <div
                          key={event.id}
                          className={`${styles.eventCard} ${event.toSave ? styles.unsaved : ''
                            } ${event.errorMessage ? styles.error : ''}`}
                        >
                          <div className={styles.cardinnerimagetitle}>
                            <div className={styles.eventField}>
                              <div className={styles.eventValue}>
                                {INDICATOR_CONFIG.showRedDot && event.toSave && (
                                  <span className={styles.redDot}>●</span>
                                )}
                                {event.name}
                                {INDICATOR_CONFIG.showUnsavedLabel && event.toSave && (
                                  <span className={styles.unsavedLabel}>(Unsaved)</span>
                                )}
                                {savingEventId === event.id && (
                                  <i className="pi pi-spin pi-spinner" style={{ marginLeft: '8px', fontSize: '1rem', color: '#0cc0df' }}></i>
                                )}
                              </div>
                              {event.errorMessage && (
                                <div className={styles.errorMessage}>
                                  {event.errorMessage}
                                </div>
                              )}
                            </div>

                            <div className={styles.eventField}>
                              <div className={styles.eventValue}>
                                {event.imageid ? (
                                  <img
                                    src={`${config.API_BASE_URL}/gallery/download/${event.imageid}`}
                                    alt={event.name || ""}
                                    className={styles.eventImage}
                                  />
                                ) : (
                                  <img
                                    src={noimage}
                                    alt={event.name || ""}
                                    className={styles.eventImage}
                                  />
                                )}
                              </div>
                            </div>
                          </div>

                          <div className={styles.cardinnerprice}>
                            <div className={styles.eventField}>
                              <label>Price</label>
                              <div className={styles.inputWithClear}>
                                <div className={styles.inputContainer}>
                                  <span className={styles.currencySymbol}>₹</span>
                                  <input
                                    type="number"
                                    value={event.price ?? ''}
                                    onChange={(e) =>
                                      handleInputChange(
                                        category.id,
                                        event.id,
                                        'price',
                                        e.target.value
                                      )
                                    }
                                    placeholder="Enter price"
                                    className={styles.priceInput}
                                  />
                                </div>
                                {(event.price && event.price !== '') && (
                                  <button
                                    type="button"
                                    onClick={() => handleClearField(category.id, event.id, 'price')}
                                    className={styles.clearButton}
                                    title="Clear price"
                                  >
                                    <i className="pi pi-times"></i>
                                  </button>
                                )}
                              </div>
                            </div>

                            <div className={styles.eventField}>
                              <label>Offer Price</label>
                              <div className={styles.inputWithClear}>
                                <div className={styles.inputContainer}>
                                  <span className={styles.currencySymbol}>₹</span>
                                  <input
                                    type="number"
                                    value={event.discountPrice ?? ''}
                                    onChange={(e) =>
                                      handleInputChange(
                                        category.id,
                                        event.id,
                                        'discountPrice',
                                        e.target.value
                                      )
                                    }
                                    placeholder="Enter offer price"
                                    className={styles.priceInput}
                                  />
                                </div>
                                {(event.discountPrice && event.discountPrice !== '') && (
                                  <button
                                    type="button"
                                    onClick={() => handleClearField(category.id, event.id, 'discountPrice')}
                                    className={styles.clearButton}
                                    title="Clear offer price"
                                  >
                                    <i className="pi pi-times"></i>
                                  </button>
                                )}
                              </div>

                              {/* Calendar appears directly under offer price when any value is entered */}
                              {event.discountPrice && event.discountPrice !== '' && (
                                <div className={styles.dateField}>
                                  <label>Offer Valid Until</label>
                                  <div className={styles.inputWithClear}>
                                    <CustomDatePicker
                                      value={event.discountValidUpto}
                                      onChange={(date) => handleInputChange(
                                        category.id,
                                        event.id,
                                        'discountValidUpto',
                                        date
                                      )}
                                      minDate={new Date().toISOString()}
                                      placeholder="Select expiry date"
                                      width="100%"
                                    />
                                  </div>
                                </div>
                              )}
                            </div>

                            {/* Save button - always present on every event card, directly
                                below the offer/date fields, so it stays visible even after
                                scrolling down to pick the offer valid date. */}
                            <button
                              type="button"
                              className={styles.saveEventButton}
                              onClick={() => handleManualSave(category.id, event.id)}
                              disabled={!event.price || savingEventId === event.id}
                            >
                              {savingEventId === event.id ? (
                                <>
                                  <i className="pi pi-spin pi-spinner"></i> Saving...
                                </>
                              ) : (
                                'Save'
                              )}
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))
            )}
          </div>
        )}
      </div>
    </main>
  );
}

export default PriestManageServices;